<template>
  <v-dialog v-model="show" width="500px">
    <ModalContentNeracaSaldo :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentNeracaSaldo from './ModalContentNeracaSaldo.vue';

export default {
  components: {
    ModalContentNeracaSaldo,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
